import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var Mail = function Mail(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0103 13.1733C12.4512 13.1733 12.8408 12.9683 13.3022 12.5068L22.2437 3.63721C21.8438 3.27832 21.1362 3.104 20.1416 3.104H3.60205C2.72021 3.104 2.09473 3.26807 1.73584 3.59619L10.7183 12.5068C11.1694 12.9683 11.5693 13.1733 12.0103 13.1733ZM0.751465 19.377L8.12402 12.0762L0.761719 4.80615C0.577148 5.13428 0.474609 5.67773 0.474609 6.44678V17.7773C0.474609 18.5259 0.566895 19.0591 0.751465 19.377ZM23.2485 19.3667C23.4229 19.0488 23.5151 18.5156 23.5151 17.7773V6.44678C23.5151 5.69824 23.4126 5.15479 23.228 4.83691L15.8965 12.0762L23.2485 19.3667ZM3.84814 21.1201H20.3877C21.29 21.1201 21.9258 20.9458 22.2949 20.6074L14.7891 13.1528L14.1533 13.7783C13.4458 14.4653 12.769 14.7935 12.0103 14.7935C11.2515 14.7935 10.5645 14.4653 9.85693 13.7783L9.22119 13.1528L1.72559 20.5869C2.13574 20.9355 2.85352 21.1201 3.84814 21.1201Z"
  })));
};

Mail.displayName = 'Mail';
export default Mail;